import React, {Component} from 'react';
import {toast} from 'react-toastify';
import {Button, Dialog, TextField} from '@betareader/design-system';
import {withRouter} from 'react-router-dom';
import {withTranslation} from 'react-i18next';
import {connect} from 'react-redux';

import {uxAnalyticsUtil} from '../../../utils';

export class InviteManuscriptCollaboratorModal extends Component {
  state = {email: '', open: false, isSendingInvite: false};

  open = () => {
    uxAnalyticsUtil.trackModalView('invite-collaborator');
    this.setState({open: true});
  };

  close = () => this.setState({open: false});

  sendInvite = async event => {
    event.preventDefault();
    const {idToken, t, currentBook} = this.props;
    const {email, isSendingInvite} = this.state;
    if (!currentBook?._id || !email || isSendingInvite) return;
    this.setState({isSendingInvite: true});
    try {
      const response = await fetch(
        `${process.env.REACT_APP_API_HOST}${process.env.REACT_APP_API_PATH}/books/${currentBook._id}/invite-members`,
        {
          method: 'POST',
          headers: {'Content-Type': 'application/json', 'br-token': idToken},
          body: JSON.stringify({email}),
        }
      );
      if (!response.ok) throw new Error('Failed to invite collaborator');
      toast.info(t('InvitationSent'));
      this.setState({email: '', open: false});
    } catch (error) {
      toast.error(t('SomethingWentWrong'));
    } finally {
      this.setState({isSendingInvite: false});
    }
  };

  render() {
    const {t} = this.props;
    const {email, open, isSendingInvite} = this.state;
    return (
      <>
        <Button onClick={this.open}>{t('InviteCollaborator')}</Button>
        <Dialog open={open} title={t('InviteCollaborator')} onClose={this.close}
          actions={
            <Button variant='secondary' onClick={this.close}>{t('Close')}</Button>
          }>
          <form onSubmit={this.sendInvite} style={{display: 'grid', gap: 'var(--br-space-3)'}}>
            <TextField id='collaborator-email' type='email' label={t('Email')}
              placeholder={t('Email')} value={email}
              onChange={event => this.setState({email: event.target.value})} />
            <p>{t('InviteCollaboratorMsg')}</p>
            <Button type='submit' disabled={isSendingInvite || !email} aria-busy={isSendingInvite}>
              {isSendingInvite ? t('Sending') : t('Send')}
            </Button>
          </form>
        </Dialog>
      </>
    );
  }
}

const mapStateToProps = state => ({
  idToken: state.user.idToken,
  currentBook: state.book.currentBook,
});

export default withTranslation()(withRouter(connect(mapStateToProps)(InviteManuscriptCollaboratorModal)));
